module.exports = __webpack_public_path__ + "static/media/tile-pause.dfea9f71.svg";